import styled from 'styled-components';
import {
  SkeletonPage,
  SkeletonSurface
} from 'components/Skeleton/styled';

export const PageWrapper = styled(SkeletonPage).attrs({})``;

export const FiltersRow = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const TableCard = styled(SkeletonSurface).attrs({})`
  overflow: hidden;
  gap: 0;
  padding: 0;
`;

export const TableHeader = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  padding: 20px;
  border-bottom: 1px solid ${props => props.theme.palette.colors.border};

  @media (max-width: 767px) {
    display: none;
  }
`;

export const TableBody = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
`;

export const TableRow = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  padding: 20px;
  border-bottom: 1px solid ${props => props.theme.palette.colors.border};

  &:last-child {
    border-bottom: 0;
  }

  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
